/**
 * Constants for Scene Management System
 */

export const DEFAULT_PATH = "/";
export const PATH_SEPARATOR = "/";
export const PARAM_PATTERN = /:(\w+)/g;
export const PARAM_REPLACEMENT = "([^/]+)";
